import { useCallback } from 'react';

import { usePaymentContext } from '../../state';
import { IReloadPrepaidCard } from '../../types';

/** Executes the First Data-backed prepaid reload mutation for any supported funding rail. */
export const useFirstDataPrepaidReload = () => {
  const { getPaymentMethods, reloadPrepaidCard } = usePaymentContext();

  const reloadWithFirstData = useCallback(
    async (reloadInput: IReloadPrepaidCard) => {
      const updatedBalance = await reloadPrepaidCard(reloadInput);
      if (updatedBalance === undefined) {
        throw new Error('Failed to reload gift card');
      }

      await getPaymentMethods();
      return updatedBalance;
    },
    [getPaymentMethods, reloadPrepaidCard]
  );

  return { reloadWithFirstData };
};
